export default "__VITE_ASSET__Dhm8uXND__"